import React from 'react';
import { IoArrowBack } from 'react-icons/io5';

export default function MobileMetroLevel2({
  level1Selection,
  getMainMenus,
  getSubSections,
  handleBack,
  handleLevel2Click,
}) {
  if (!level1Selection) return null;

  const menu = getMainMenus().find((m) => m.id === level1Selection);
  const sections = getSubSections(level1Selection);

  return (
    <div className="mobile-metro-level mobile-metro-level-2">
      <div className="mobile-metro-breadcrumb" onClick={handleBack}>
        <IoArrowBack className="breadcrumb-back-icon" />
        <menu.icon className="breadcrumb-icon" />
        <span className="breadcrumb-title">{menu.title}</span>
      </div>

      <div className="mobile-metro-subsections">
        {sections.map((section, idx) => (
          <div
            key={section.id}
            className="mobile-metro-subsection"
            style={{ animationDelay: `${idx * 50}ms` }}
            onClick={() => handleLevel2Click(section.id)}
          >
            <div className="subsection-title">{section.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
